import { render } from "./App.vue?vue&type=template&id=98a5a85a"
const script = {}

import exportComponent from "/devcloud/slavespace/slave1-new/workspace/j_0fNImIEQ/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__